import { render } from "./modelBindGift.vue?vue&type=template&id=c661ba6e&scoped=true"
import script from "./modelBindGift.vue?vue&type=script&lang=js"
export * from "./modelBindGift.vue?vue&type=script&lang=js"

import "./modelBindGift.vue?vue&type=style&index=0&id=c661ba6e&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c661ba6e"]])

export default __exports__